var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Transition',{attrs:{"name":"fade"}},[(!_vm.forget)?_c('SignIn',{on:{"switchForget":_vm.switchForget}}):_vm._e(),_vm._v(" "),(_vm.forget)?_c('RecoverPassword',{on:{"switchForget":_vm.switchForget}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d40fa8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/Login.vue
// module id = 933
// module chunks = 2